import React from 'react';

import { formatShortToolError } from '@elara/client-core/lib/errors';
import { cn } from '@elara/client-core/lib/utils';

import { useUserProfileState } from '#states/hooks.js';
import { Alert, AlertDescription, AlertTitle } from '#ui/alert.js';
import { MaterialIcon } from '#ui/MaterialIcon.js';

export interface WidgetErrorStateProps {
  /** The error message to display */
  message: string;
  /** The error to display */
  error?: unknown;
  /** Additional CSS classes to apply */
  className?: string;
}

/**
 * Reusable error state component for widgets.
 * Displays an error message with consistent styling and icon.
 */
export function WidgetErrorState({ message, error, className }: WidgetErrorStateProps) {
  const user = useUserProfileState();
  return (
    <Alert variant="destructive" className={cn(className)}>
      <AlertTitle className="flex items-center gap-2">
        <MaterialIcon icon="error" /> {message}
      </AlertTitle>
      {user.isPrivileged && <AlertDescription>{formatShortToolError(error, { maxLength: 512 })}</AlertDescription>}
    </Alert>
  );
}
